// Los temas de color. La lista vive SOLO acá: la API valida contra ella y la
// web arma el selector con ella. Los colores de cada uno están en src/index.css
// (bloques [data-tema="..."]); sumar un tema es agregarlo en los dos lados.
//
// Elegidos por Marcos el 2026-09-30 sobre la maqueta: FIP por defecto, y los
// colores de las canchas (verde, rojo, negro de Premier Padel) más rosa para
// las categorías femeninas.

export const TEMAS = ['fip', 'verde', 'rojo', 'negro', 'rosa'] as const;
export type Tema = (typeof TEMAS)[number];

export const TEMA_POR_DEFECTO: Tema = 'fip';

export const NOMBRE_TEMA: Record<Tema, string> = {
  fip: 'FIP',
  verde: 'Verde',
  rojo: 'Rojo',
  negro: 'Negro',
  rosa: 'Rosa',
};

export function esTema(valor: unknown): valor is Tema {
  return typeof valor === 'string' && (TEMAS as readonly string[]).includes(valor);
}

/** El tema con el que se ve una categoría: el suyo si tiene, si no el del torneo. */
export function temaDeCategoria(torneo: Tema, categoria: Tema | null): Tema {
  return categoria ?? torneo;
}
